import type { ContactGeoCode } from "../types";

export const CONTINENT_OPTIONS: Array<{
  code: ContactGeoCode;
  labelKey: string;
  fallback: string;
}> = [
  {
    code: "AF",
    labelKey: "crm.whatsapp.broadcasts.cohort.continent_AF",
    fallback: "Africa",
  },
  {
    code: "AS",
    labelKey: "crm.whatsapp.broadcasts.cohort.continent_AS",
    fallback: "Asia",
  },
  {
    code: "EU",
    labelKey: "crm.whatsapp.broadcasts.cohort.continent_EU",
    fallback: "Europe",
  },
  {
    code: "NA",
    labelKey: "crm.whatsapp.broadcasts.cohort.continent_NA",
    fallback: "North America",
  },
  {
    code: "OC",
    labelKey: "crm.whatsapp.broadcasts.cohort.continent_OC",
    fallback: "Oceania",
  },
  {
    code: "SA",
    labelKey: "crm.whatsapp.broadcasts.cohort.continent_SA",
    fallback: "South America",
  },
  {
    code: "UNKNOWN",
    labelKey: "crm.whatsapp.broadcasts.cohort.continent_UNKNOWN",
    fallback: "Unknown",
  },
];

export const continentLabel = (code: string): string =>
  CONTINENT_OPTIONS.find((option) => option.code === code)?.fallback ?? code;

export const parseCodeFilter = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value
      .map(String)
      .map((item) => item.trim())
      .filter(Boolean);
  }
  if (typeof value !== "string") {
    return [];
  }
  const trimmed = value.trim();
  const withoutBrackets =
    (trimmed.startsWith("{") && trimmed.endsWith("}")) ||
    (trimmed.startsWith("(") && trimmed.endsWith(")"))
      ? trimmed.slice(1, -1)
      : trimmed;
  return withoutBrackets
    .split(",")
    .map((item) => item.trim())
    .filter(Boolean);
};

export const formatCodeFilter = (codes: string[]): string | undefined => {
  const unique = [...new Set(codes.map((code) => code.trim()).filter(Boolean))];
  return unique.length ? unique.join(",") : undefined;
};

export const toggleCode = (codes: string[], code: string): string[] =>
  codes.includes(code)
    ? codes.filter((item) => item !== code)
    : [...codes, code];
